export default {
  "nav.home": "Strona główna",
  "nav.categories": "Kategorie",
  "nav.articles": "Poradniki",
  "nav.faq": "FAQ",
  "nav.shopGuide": "Przewodnik zakupowy",

  "hero.eyebrow": "USFans Spreadsheet i Centrum Zasobów",
  "hero.title": "USFans Spreadsheet — znajdź, przeglądaj i porównuj zasoby USFans",
  "hero.subtitle": "Znajdź uporządkowane zasoby arkusza USFans, listy twórców, recenzje, poradniki wysyłkowe, kupony i porównania — wszystko w jednym, łatwym w nawigacji miejscu.",
  "hero.ctaPrimary": "USFans Spreadsheet",
  "hero.ctaSecondary": "Kup teraz",
  "hero.trust": "Niezależne źródło • Aktualne informacje • Bezpieczeństwo przede wszystkim",
  "hero.searchPlaceholder": "Szukaj arkuszy, twórców, wysyłki, kuponów, recenzji...",

  "categories.title": "Przeglądaj według kategorii",
  "categories.subtitle": "Przejdź od razu do produktów, których szukasz, w głównym sklepie.",
  "categories.dropdownLabel": "Wybierz kategorię",
  "categories.view": "Zobacz kategorię",

  "articles.title": "USFans Spreadsheet: poradniki i zasoby",
  "articles.subtitle": "Przeczytaj nasze szczegółowe poradniki, aby zrozumieć, jak działają zasoby arkusza USFans, listy twórców i porównania.",
  "articles.readMore": "Przeczytaj pełny poradnik",

  "faq.title": "Często zadawane pytania",
  "faq.subtitle": "Szybkie, praktyczne odpowiedzi na temat zasobów arkusza USFans.",

  "cta.title": "Gotowy, aby odkryć zasoby USFans?",
  "cta.subtitle": "Poznaj nasze zasoby arkusza USFans, poradniki, porównania i informacje o bezpieczeństwie — a następnie przejdź do głównego sklepu.",

  "footer.desc": "USFansLink to niezależne centrum zasobów z linkami do arkuszy USFans, listami twórców, recenzjami, poradnikami wysyłkowymi, kuponami i porównaniami.",
  "footer.disclaimer": "USFansLink jest niezależnym źródłem informacji. Nie jesteśmy powiązani z żadną marką, chyba że wyraźnie to zaznaczono.",
  "footer.rights": "Wszelkie prawa zastrzeżone.",
  "footer.explore": "Odkrywaj",
  "footer.categories": "Kategorie",
  "footer.language": "Język",

  "category.shoes": "Buty",
  "category.hoodies": "Bluzy/Swetry",
  "category.tshirts": "Koszulki",
  "category.jackets": "Kurtki",
  "category.pants": "Spodnie/Szorty",
  "category.headwear": "Nakrycia głowy",
  "category.sets": "Zestawy",
  "category.underwear": "Bielizna",
  "category.jersey": "Koszulka sportowa",
  "category.accessories": "Akcesoria",
  "category.bags": "Torby",
  "category.belts": "Paski",
  "category.perfumes": "Perfumy",
  "category.other": "Inne rzeczy",

  "common.backHome": "Wróć do strony głównej",
  "common.readArticle": "Przeczytaj artykuł",
  "common.published": "Opublikowano",
  "common.updated": "Zaktualizowano",
  "common.author": "Autor",
  "common.readTime": "min czytania",
  "common.onThisPage": "Na tej stronie",
  "common.relatedResources": "Powiązane zasoby",
  "common.quickAnswer": "Szybka odpowiedź",
  "common.faqShort": "FAQ",
};